import script from "./detail.vue?vue&type=script&setup=true&lang=ts&name=CeciDetail"
export * from "./detail.vue?vue&type=script&setup=true&lang=ts&name=CeciDetail"

import "./detail.vue?vue&type=style&index=0&id=7daf9bc9&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7daf9bc9"]])

export default __exports__